module.exports = __webpack_public_path__ + "static/img/mall_tab_icon_8_2.3cbf93d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mall/mall_tab_icon_8_2.png
// module id = 0GcX
// module chunks = 0